(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cgd-archives-preview"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-cga-teaser]').forEach(root=>{const track=root.querySelector('.cga-teaser-track'),button=root.querySelector('[data-cga-pause]');let paused=matchMedia('(prefers-reduced-motion: reduce)').matches,interacting=false;const label=()=>button.textContent=paused?button.dataset.play:button.dataset.pause;label();button.addEventListener('click',()=>{paused=!paused;label()});root.addEventListener('mouseenter',()=>interacting=true);root.addEventListener('mouseleave',()=>interacting=false);root.addEventListener('focusin',()=>interacting=true);root.addEventListener('focusout',()=>interacting=false);track.addEventListener('touchstart',()=>{paused=true;label()},{passive:true});setInterval(()=>{if(paused||interacting||document.hidden||!root.isConnected)return;const r=root.getBoundingClientRect();if(r.bottom<0||r.top>innerHeight)return;const end=track.scrollWidth-track.clientWidth;track.scrollTo({left:track.scrollLeft>=end-4?0:Math.min(end,track.scrollLeft+track.firstElementChild.offsetWidth+20),behavior:'smooth'})},5500)});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cgd-archives"] && !Shopify.designMode) return;
  try {
    
 function initCga(root){if(root.dataset.ready)return;root.dataset.ready='1';const cards=[...root.querySelectorAll('[data-cga-category]')];root.querySelectorAll('[data-cga-filter]').forEach(button=>button.addEventListener('click',()=>{root.querySelectorAll('[data-cga-filter]').forEach(b=>b.setAttribute('aria-pressed',String(b===button)));let count=0;cards.forEach(card=>{card.hidden=button.dataset.cgaFilter!=='all'&&card.dataset.cgaCategory!==button.dataset.cgaFilter;if(!card.hidden)count++});root.querySelector('.cga-empty').hidden=count>0}));root.querySelectorAll('[data-cga-open]').forEach(link=>link.addEventListener('click',()=>{document.getElementById(link.dataset.cgaOpen).open=true}));}
 document.querySelectorAll('[data-cga]').forEach(initCga);document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-cga]').forEach(initCga));
 
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cgd-midnight-flash"] && !Shopify.designMode) return;
  try {
    
(() => {
  function setup() {
    document.querySelectorAll('.cgd-midnight').forEach(root => {
      if (root.dataset.started) return;
      root.dataset.started = 'true';
      const end = Date.parse(root.dataset.flashEnd);
      function tick() {
        const remaining = Math.max(0, Math.ceil((end - Date.now()) / 1000));
        if (!remaining) { root.closest('.shopify-section')?.remove(); clearInterval(timer); return; }
        root.querySelector('[data-hours]').textContent = String(Math.floor(remaining / 3600)).padStart(2,'0');
        root.querySelector('[data-minutes]').textContent = String(Math.floor(remaining % 3600 / 60)).padStart(2,'0');
        root.querySelector('[data-seconds]').textContent = String(remaining % 60).padStart(2,'0');
      }
      const timer = setInterval(tick, 1000);
      tick();
    });
  }
  setup();
  document.addEventListener('shopify:section:load', setup);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cgd-new-treasures"] && !Shopify.designMode) return;
  try {
    
async function cgdRefreshFresh(section) {
  if (section.dataset.cgdFreshLoaded) return;
  section.dataset.cgdFreshLoaded = 'true';
  const url = new URL((window.Shopify?.routes?.root || '/') + 'collections/all', window.location.origin);
  url.searchParams.set('sort_by', 'created-descending');
  url.searchParams.set('filter.v.availability', '1');
  url.searchParams.set('section_id', 'cgd-fresh-feed');
  const previewId = new URLSearchParams(window.location.search).get('preview_theme_id');
  if (previewId) url.searchParams.set('preview_theme_id', previewId);
  try {
    const response = await fetch(url, {credentials:'same-origin'});
    if (!response.ok) return;
    const documentFragment = new DOMParser().parseFromString(await response.text(), 'text/html');
    const feed = documentFragment.querySelector('[data-cgd-fresh-feed]');
    if (feed && !documentFragment.body.textContent.includes('Liquid error')) {
      section.querySelector('[data-cgd-fresh-grid]').replaceChildren(...feed.childNodes);
    }
  } catch {}
}
document.querySelectorAll('[data-cgd-fresh-section]').forEach(cgdRefreshFresh);
document.addEventListener('shopify:section:load', (event) => {
  event.target.querySelectorAll('[data-cgd-fresh-section]').forEach(cgdRefreshFresh);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["charmageddon-dressing-room"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init() {
    document.querySelectorAll('.cgd-tryon').forEach(function (room) {
      if (room.dataset.ready === '2') return;
      room.dataset.ready = '2';
      var stage = room.querySelector('[data-stage]'), piece = room.querySelector('[data-piece]');
      if (!stage || !piece) return;
      var bg = room.querySelector('[data-bg]'), upload = room.querySelector('[data-upload]');
      var scale = room.querySelector('[data-scale]'), rotate = room.querySelector('[data-rotate]');
      var photoScale = room.querySelector('[data-photo-scale]'), status = room.querySelector('[data-status]');
      var sampleButtons = room.querySelectorAll('[data-sample-bag]');
      var s = {x:0,y:0,scale:0.95,rot:0}, photo = {x:0,y:0,scale:1};
      var mode = 'piece', points = new Map(), anchor = null, frame = 0, serial = 0, activeUrl = null;
      var cutoutTask = null, lastWidth = 0, lastHeight = 0;
      var mobile = window.matchMedia('(max-width:800px)'), grid = room.querySelector('.cgd-tryon__grid');
      var controls = room.querySelector('.cgd-tryon__controls'), post = room.querySelector('.cgd-post-upload');
      var modes = room.querySelector('.cgd-editor-modes'), hint = room.querySelector('.cgd-tryon__hint');
      var originalFrame = stage.parentElement, moved = [], more = null, actions = null;
      var header = document.querySelector('#header-component'), compactFrame = 0;
      var compactAbort = new AbortController(), compactSignal = compactAbort.signal;
      function relocate(node, parent, before) {
        var marker = document.createComment(''); node.before(marker); moved.push([node,marker]);
        parent.insertBefore(node,before||null);
      }
      function compactLayout() {
        if(mobile.matches && !more) {
          room.classList.add('cgd-compact');
          relocate(stage,grid,originalFrame); originalFrame.hidden=true;
          relocate(post,controls,controls.firstChild);
          relocate(modes,post,post.firstChild);
          more=document.createElement('details'); more.className='cgd-more';
          var summary=document.createElement('summary'); summary.textContent=room.dataset.moreLabel;
          var body=document.createElement('div'); body.className='cgd-more__body';
          more.append(summary,body); post.insertBefore(more,room.querySelector('[data-save]'));
          relocate(photoScale.closest('label'),body);
          relocate(room.querySelector('[data-fit]'),body);
          relocate(room.querySelector('[data-reset]'),body);
          relocate(hint,body);
          actions=document.createElement('div'); actions.className='cgd-actions'; more.after(actions);
          relocate(room.querySelector('[data-piece-action]'),actions);
          relocate(room.querySelector('[data-save]'),actions);
          relocate(room.querySelector('[data-request]'),actions);
        } else if(!mobile.matches && more) {
          moved.reverse().forEach(function(pair){pair[1].replaceWith(pair[0]);}); moved=[];
          more.remove();actions.remove();more=actions=null;originalFrame.hidden=false;
          room.classList.remove('cgd-compact');
        }
      }
      function compactTop() {
        var height=header&&header.hasAttribute('sticky')?header.getBoundingClientRect().height:0;
        room.style.setProperty('--cgd-preview-top',(height+8)+'px');
        return height+8;
      }
      function activeRoom() {
        compactFrame=0;
        var bounds=room.getBoundingClientRect(), top=compactTop();
        var vh=window.visualViewport?window.visualViewport.height:window.innerHeight;
        document.body.classList.toggle('cgd-room-active',mobile.matches&&bounds.top<vh*.8&&bounds.bottom>top+40);
      }
      function scheduleActive() {if(!compactFrame)compactFrame=requestAnimationFrame(activeRoom);}
      window.addEventListener('scroll',scheduleActive,{passive:true,signal:compactSignal});
      window.addEventListener('resize',scheduleActive,{passive:true,signal:compactSignal});
      if(window.visualViewport)window.visualViewport.addEventListener('resize',function(){
        if(window.visualViewport.scale===1){layout();scheduleActive();}
      },{passive:true,signal:compactSignal});
      document.addEventListener('shopify:section:unload',function(e){
        if(e.target.contains(room)){compactAbort.abort();cancelAnimationFrame(compactFrame);document.body.classList.remove('cgd-room-active');}
      },{signal:compactSignal});
      compactLayout();scheduleActive();
      function say(t) { status.textContent = t; }
      function clamp(n,a,b) { return Math.max(a,Math.min(b,n)); }
      function render() {
        frame = 0;
        var r = stage.getBoundingClientRect();
        s.x = clamp(s.x,-r.width/2,r.width/2); s.y = clamp(s.y,-r.height/2,r.height/2);
        photo.x = clamp(photo.x,-r.width*.9,r.width*.9); photo.y = clamp(photo.y,-r.height*.9,r.height*.9);
        piece.style.transform = 'translate(-50%,'+(room.dataset.mode === 'bag_charm' ? '-7%' : '-50%')+') translate('+s.x+'px,'+s.y+'px) scale('+s.scale+') rotate('+s.rot+'deg)';
        bg.style.transform = 'translate('+photo.x+'px,'+photo.y+'px) scale('+photo.scale+')';
        scale.value = Math.round(s.scale*100); rotate.value = s.rot; photoScale.value = Math.round(photo.scale*100);
      }
      function draw() { if (!frame) frame = requestAnimationFrame(render); }
      function home() {
        var r = stage.getBoundingClientRect();
        s.x = room.dataset.mode === 'bag_charm' ? -r.width*.19 : 0;
        s.y = room.dataset.mode === 'bag_charm' ? -r.height*.09 : r.height*.01;
      }
      function clearGesture() {
        var ids = Array.from(points.keys()); points.clear(); anchor = null;
        ids.forEach(function(id) { try { if(stage.hasPointerCapture(id)) stage.releasePointerCapture(id); } catch (_) {} });
      }
      function fit() { clearGesture(); photo.x=0; photo.y=0; photo.scale=1; draw(); }
      function reset() { clearGesture(); home(); s.scale=room.dataset.overlay.indexOf('/prada-heart-dream-necklace-dressing-room-v2.png')>=0?.45:.95; s.rot=0; fit(); }
      function setMode(value) {
        clearGesture(); mode=value;
        stage.setAttribute('data-edit-mode', bg.hidden ? 'scroll' : mode);
        room.querySelectorAll('[data-edit]').forEach(function(b) { b.setAttribute('aria-pressed',String(b.dataset.edit === mode)); });
      }
      function layout() {
        compactLayout();
        clearGesture();
        var w = stage.clientWidth, h = Math.round(Math.min(w*1.25, Math.max(240,window.innerHeight*.6),680));
        if(mobile.matches){
          var viewport=window.visualViewport?window.visualViewport.height:window.innerHeight;
          h=Math.round(Math.max(120,(viewport-compactTop())*.4));
        }
        stage.style.height = h+'px';
        if(lastWidth && lastHeight) { s.x*=w/lastWidth; s.y*=h/lastHeight; photo.x*=w/lastWidth; photo.y*=h/lastHeight; }
        lastWidth=w; lastHeight=h; draw();
      }
      function rebase() {
        var ps=Array.from(points.values()), target=mode==='photo'?photo:s;
        if (!ps.length) { anchor=null; return; }
        var a=ps[0], b=ps[1]||a;
        anchor={x:target.x,y:target.y,scale:target.scale,cx:(a.x+b.x)/2,cy:(a.y+b.y)/2,dist:ps.length>1?Math.hypot(a.x-b.x,a.y-b.y):0,count:ps.length};
      }
      function start(id,x,y) {
        if(bg.hidden||mode==='scroll'||points.size>=2)return false;
        points.set(id,{x:x,y:y}); rebase(); return true;
      }
      function move(id,x,y) {
        if(!points.has(id)||!anchor)return;
        points.set(id,{x:x,y:y});
        var ps=Array.from(points.values()),a=ps[0],b=ps[1]||a,target=mode==='photo'?photo:s;
        target.x=anchor.x+(a.x+b.x)/2-anchor.cx; target.y=anchor.y+(a.y+b.y)/2-anchor.cy;
        if(ps.length===2&&anchor.dist>0)target.scale=clamp(anchor.scale*Math.hypot(a.x-b.x,a.y-b.y)/anchor.dist,mode==='photo'?.25:.35,mode==='photo'?3:1.8);
        draw();
      }
      function end(id) { points.delete(id); rebase(); }
      if(window.PointerEvent) {
        stage.addEventListener('pointerdown',function(e){if(e.pointerType==='mouse'&&e.button!==0)return;if(start(e.pointerId,e.clientX,e.clientY)){try{stage.setPointerCapture(e.pointerId);}catch(_){} if(e.cancelable)e.preventDefault();}});
        stage.addEventListener('pointermove',function(e){move(e.pointerId,e.clientX,e.clientY);});
        stage.addEventListener('pointerup',function(e){end(e.pointerId);try{stage.releasePointerCapture(e.pointerId);}catch(_){}});
        stage.addEventListener('pointercancel',clearGesture);
        stage.addEventListener('lostpointercapture',function(e){if(points.has(e.pointerId))clearGesture();});
      } else {
        stage.addEventListener('touchstart',function(e){if(bg.hidden||mode==='scroll')return;Array.from(e.changedTouches).forEach(function(t){start(t.identifier,t.clientX,t.clientY);});if(e.cancelable)e.preventDefault();},{passive:false});
        stage.addEventListener('touchmove',function(e){if(!points.size)return;Array.from(e.changedTouches).forEach(function(t){move(t.identifier,t.clientX,t.clientY);});if(e.cancelable)e.preventDefault();},{passive:false});
        stage.addEventListener('touchend',function(e){Array.from(e.changedTouches).forEach(function(t){end(t.identifier);});});
        stage.addEventListener('touchcancel',clearGesture);
      }
      window.addEventListener('blur',clearGesture);
      window.addEventListener('pagehide',clearGesture);
      document.addEventListener('visibilitychange',function(){if(document.hidden)clearGesture();});
      window.addEventListener('resize',layout);
      room.querySelectorAll('[data-edit]').forEach(function(b){b.addEventListener('click',function(){setMode(b.dataset.edit);});});
      room.querySelector('[data-upload-button]').addEventListener('click',function(){clearGesture();upload.click();});
      upload.addEventListener('cancel',clearGesture);
      function loadImage(src,remote) {
        return new Promise(function(resolve,reject){
          var im=new Image(),timer=setTimeout(function(){im.onload=im.onerror=null;reject(new Error('timeout'));},20000);
          if(remote)im.crossOrigin='anonymous';
          im.onload=function(){clearTimeout(timer);resolve(im);};
          im.onerror=function(){clearTimeout(timer);reject(new Error('decode'));}; im.src=src;
        });
      }
      function shrink(im,type) {
        return new Promise(function(resolve,reject){
          try {
            var factor=Math.min(1,1600/Math.max(im.naturalWidth,im.naturalHeight)), c=document.createElement('canvas');
            c.width=Math.max(1,Math.round(im.naturalWidth*factor)); c.height=Math.max(1,Math.round(im.naturalHeight*factor));
            c.getContext('2d').drawImage(im,0,0,c.width,c.height);
            c.toBlob(function(blob){c.width=c.height=1;blob?resolve(URL.createObjectURL(blob)):reject(new Error('encode'));},type==='image/png'?'image/png':'image/jpeg',.88);
          } catch(e) { reject(e); }
        });
      }
      function showBackground(src,file) {
        clearGesture(); var token=++serial, local=file?src:null, reduced=null;
        say('Opening photo…'); room.setAttribute('aria-busy','true');
        loadImage(src,!file).then(function(im){
          if(token!==serial)throw new Error('stale');
          if(!file)return src;
          if(im.naturalWidth*im.naturalHeight>40000000)throw new Error('large');
          return shrink(im,file.type);
        }).then(function(url){
          reduced=file?url:null;
          if(token!==serial)throw new Error('stale');
          return loadImage(url,false).then(function(){return url;});
        }).then(function(url){
          if(token!==serial)throw new Error('stale');
          var previous=activeUrl; activeUrl=file?url:null;
          bg.src=url; bg.hidden=false; stage.classList.add('is-loaded');
          room.querySelector('[data-placeholder]').hidden=true;
          room.querySelectorAll('[data-after-upload]').forEach(function(el){el.hidden=false;});
          layout(); reset(); setMode('piece');
          if(previous)URL.revokeObjectURL(previous);
          if(!cutoutTask)cutoutTask=smartCutout();
          cutoutTask.then(function(){if(token===serial)piece.hidden=false;});
          say('Photo ready. Choose Move photo or Move piece. Swipe outside the frame to scroll.');
          reduced=null;
        }).catch(function(e){
          if(token!==serial)return;
          say(e.message==='large'?'This photo is too large for the editor. Try a smaller copy or screenshot.':'This photo could not be opened. Try a JPG, PNG, or a screenshot.');
        }).then(function(){
          if(local)URL.revokeObjectURL(local);
          if(reduced)URL.revokeObjectURL(reduced);
          if(token===serial){room.removeAttribute('aria-busy');clearGesture();}
        });
      }
      upload.addEventListener('change',function(){
        clearGesture(); var f=upload.files&&upload.files[0];upload.value='';if(!f)return;
        if(f.type&&f.type.indexOf('image/')!==0){say('Please choose an image file.');return;}
        if(f.size>20*1024*1024){say('Please choose a photo under 20 MB.');return;}
        sampleButtons.forEach(function(b){b.classList.remove('is-selected');});
        showBackground(URL.createObjectURL(f),f);
      });
      var sampleBagUrls={
  black:'https://cdn.shopify.com/s/files/1/0858/2722/3787/files/dressing-room-sample-black.png?v=1790877252',
  cream:'https://cdn.shopify.com/s/files/1/0858/2722/3787/files/dressing-room-sample-cream.png?v=1790877258',
  tan:'https://cdn.shopify.com/s/files/1/0858/2722/3787/files/dressing-room-sample-tan.png?v=1790877262',
  brown:'https://cdn.shopify.com/s/files/1/0858/2722/3787/files/dressing-room-sample-brown.png?v=1790877267'
};
      sampleButtons.forEach(function(btn){btn.addEventListener('click',function(){var src=sampleBagUrls[btn.dataset.sampleBag];if(src){showBackground(src);sampleButtons.forEach(function(b){b.classList.toggle('is-selected',b===btn);});}});});
      function smartCutout(){if(room.dataset.customOverlay==='true'||room.dataset.mode!=='necklace')return Promise.resolve();return new Promise(function(resolve){var im=new Image();im.crossOrigin='anonymous';im.onload=function(){try{var sx=Math.round(im.naturalWidth*.2),sy=Math.round(im.naturalHeight*.08),sw=Math.round(im.naturalWidth*.6),sh=Math.round(im.naturalHeight*.68);var cv=document.createElement('canvas');cv.width=sw;cv.height=sh;var cx=cv.getContext('2d',{willReadFrequently:true});cx.drawImage(im,sx,sy,sw,sh,0,0,sw,sh);var d=cx.getImageData(0,0,sw,sh),p=d.data;for(var y=0;y<sh;y++){for(var x=0;x<sw;x++){var i=(y*sw+x)*4,r=p[i]/255,g=p[i+1]/255,b=p[i+2]/255,max=Math.max(r,g,b),min=Math.min(r,g,b),delta=max-min,sat=max===0?0:delta/max,val=max,nx=x/sw,ny=y/sh;var leftLine=.24+(.5-.24)*Math.min(ny/.42,1),rightLine=.76+(.5-.76)*Math.min(ny/.42,1),left=Math.abs(nx-leftLine),right=Math.abs(nx-rightLine);var chainZone=ny<.44&&(left<.035||right<.035),bailZone=ny>.32&&ny<.5&&Math.abs(nx-.5)<.075,pendZone=((nx-.5)*(nx-.5)/(.155*.155)+(ny-.585)*(ny-.585)/(.16*.16))<1;var silver=val>.34&&sat<.28;var pink=(r>g*1.08&&r>b*1.04&&sat>.16&&val>.28);var keep=(chainZone&&silver)||(bailZone&&silver)||(pendZone&&pink);if(!keep){p[i+3]=0}else{var a=Math.min(1,Math.max(.35,(val-.2)*1.7));p[i+3]=Math.round(255*a)}}}cx.putImageData(d,0,0);piece.src=cv.toDataURL('image/png');resolve()}catch(e){resolve()}};im.onerror=resolve;im.src=piece.src})}
      scale.addEventListener('input',function(){s.scale=Number(scale.value)/100;draw();});
      rotate.addEventListener('input',function(){s.rot=Number(rotate.value);draw();});
      photoScale.addEventListener('input',function(){photo.scale=Number(photoScale.value)/100;draw();});
      room.querySelector('[data-fit]').addEventListener('click',fit);
      room.querySelectorAll('[data-nudge]').forEach(function(b){b.addEventListener('click',function(){var t=mode==='photo'?photo:s,d=b.dataset.nudge;if(d==='up')t.y-=10;if(d==='down')t.y+=10;if(d==='left')t.x-=10;if(d==='right')t.x+=10;if(d==='center'){if(mode==='photo'){photo.x=photo.y=0;}else home();}draw();});});
      room.querySelector('[data-reset]').addEventListener('click',reset);
      room.querySelector('[data-save]').addEventListener('click',function(){
        clearGesture();render();if(bg.hidden||piece.hidden){say('Add a photo first.');return;}
        var r=stage.getBoundingClientRect(), ps={x:s.x,y:s.y,scale:s.scale,rot:s.rot}, bs={x:photo.x,y:photo.y,scale:photo.scale}, base=piece.offsetWidth;
        Promise.all([loadImage(bg.src,true),loadImage(piece.src,true)]).then(function(images){
          var c=document.createElement('canvas'),ratio=Math.min(1600/Math.max(r.width,r.height),2);
          c.width=Math.round(r.width*ratio);c.height=Math.round(r.height*ratio);var ctx=c.getContext('2d'),bi=images[0],pi=images[1];
          ctx.fillStyle='#fff9ef';ctx.fillRect(0,0,c.width,c.height);
          var fitScale=Math.min(c.width/bi.naturalWidth,c.height/bi.naturalHeight)*bs.scale,bw=bi.naturalWidth*fitScale,bh=bi.naturalHeight*fitScale;
          ctx.drawImage(bi,(c.width-bw)/2+bs.x*ratio,(c.height-bh)/2+bs.y*ratio,bw,bh);
          var w=base*ps.scale*ratio,h=w*pi.naturalHeight/pi.naturalWidth;
          ctx.translate(c.width/2+ps.x*ratio,c.height/2+ps.y*ratio);ctx.rotate(ps.rot*Math.PI/180);
          ctx.drawImage(pi,-w/2,room.dataset.mode==='bag_charm'?-h*.07:-h/2,w,h);
          c.toBlob(function(blob){c.width=c.height=1;if(!blob){say('Please take a screenshot to keep this preview.');return;}var url=URL.createObjectURL(blob),a=document.createElement('a');a.href=url;a.download='charmageddon-preview.png';document.body.appendChild(a);a.click();a.remove();setTimeout(function(){URL.revokeObjectURL(url);},60000);say('Preview ready. Check your downloads, or save the opened image.');},'image/png');
        }).catch(function(){say('Preview could not be saved. Please try again or take a screenshot.');});
      });
      room.querySelector('[data-request]').addEventListener('click',function(){var a=room.querySelector('[data-request]');try{var u=new URL(room.dataset.request||a.href,location.origin);u.searchParams.set('product',room.dataset.product);u.searchParams.set('product_url',location.href);u.searchParams.set('try_on',room.dataset.mode);a.href=u.toString();}catch(_){}});
      layout();reset();setMode('piece');
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
  document.addEventListener('shopify:section:load',init);
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
